import { RG53 } from "./PesoSalesAndNumberOfCustomers/RG53";
import { RG53_Share } from "./ShareByCustomerGroupSales/RG53";

export const RegionCustomerSales = {
  "sections": [
    RG53,
    RG53_Share
  ]
}